import type { BundleType } from '#resources/nls/bundle';
import { useTranslationBundle } from '#hooks/UNSAFE_useTranslationBundle';
import { IconButton } from '#UNSAFE_IconButton';
import type { TestIdProps } from '#hooks/UNSAFE_useTestId';
import { DeleteIcon } from '#PRIVATE_ThemedIcons/DeleteIcon';
import { TabbableModeContext } from '#hooks/UNSAFE_useTabbableMode';

type Props = {
  onClick?: () => void;
} & TestIdProps;

/**
 * ClearIcon is used to clear an input value.
 * @param onClick Callback for clearing value when button is clicked
 * @param testId ID used for testing purposes
 */
export function ClearIcon({ onClick, testId }: Props) {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const clearStr = translations.formControl_clear();

  return (
    <TabbableModeContext.Provider value={{ isTabbable: false }}>
      <div aria-hidden="true">
        <IconButton variant="ghost" size="sm" onAction={onClick} tooltip={clearStr} testId={testId}>
          <DeleteIcon />
        </IconButton>
      </div>
    </TabbableModeContext.Provider>
  );
}
